import { ListingType } from '../../../components';
import { APIListingSubStatus } from '../types';

/**
 * Maps over the API Listing item's subStatus and formats the correct value for displaying the type in the listing card
 */
export function mapListingType(apiSubStatus: APIListingSubStatus): ListingType {
  switch (apiSubStatus) {
    case 'Negotiable':
    case 'Referred':
      return 'referred';
    case 'Auction':
    default:
      return 'auction';
  }
}
